var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.07 14.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04,2.91c.53,.44,1.05,.87,1.57,1.29,1.58,1.3,3.17,2.61,4.75,3.91,.09,.07,.13,.14,.13,.26,0,1.74,0,3.48,0,5.22,0,.47-.3,.78-.77,.78-1.37,0-2.74,0-4.11,0-.04,0-.08,0-.14-.01v-4.28h-2.87v4.29h-.2c-1.33,0-2.66,0-3.99,0-.55,0-.83-.29-.83-.84,0-1.69,0-3.37,0-5.06,0-.18,.05-.3,.19-.41,2.05-1.68,4.08-3.36,6.13-5.04,.04-.03,.08-.07,.14-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03,1.92c-1,.84-1.99,1.66-2.98,2.48-1.56,1.3-3.12,2.61-4.69,3.91-.26,.21-.45,.2-.66-.06-.18-.22-.36-.43-.54-.65-.23-.27-.21-.45,.06-.67,2-1.66,3.99-3.33,5.99-4.99,.65-.54,1.29-1.08,1.94-1.61,.46-.38,.97-.42,1.5-.18,.14,.06,.27,.17,.39,.27,.81,.68,1.62,1.36,2.44,2.04,.04,.03,.08,.06,.14,.11,0-.08,0-.14,0-.19,0-.62,0-1.25,0-1.87,0-.35,.12-.46,.47-.46,.65,0,1.29,0,1.94,0,.33,0,.46,.13,.46,.46,0,1.43,0,2.87,0,4.3,0,.12,.04,.2,.13,.28,.74,.6,1.47,1.22,2.2,1.82,.31,.26,.33,.42,.06,.74-.17,.21-.35,.42-.52,.62-.21,.25-.4,.27-.65,.06-2.48-2.07-4.97-4.14-7.45-6.21-.07-.06-.14-.12-.23-.19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c82d6b1af4857116eac5ea685603612e.svg";
export { ForwardRef as ReactComponent };